import React from 'react';
import PageHeader from '../components/PageHeader';
import AboutSection from '../components/AboutSection';
import TravelGuide from '../components/TravelGuide';

const About = () => {
    return (
        <>
            <PageHeader
                title="About Us"
                image="img/about-banner.jpg" // use your own path
                breadcrumbs={[
                    { label: "About", active: true },
                ]}
            />
            <AboutSection />
            {/* <TravelGuide /> */}
        </>
    );
};

export default About;
